/* eslint-disable no-mixed-spaces-and-tabs */
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import {
	GET_RELATIONSHIP_SETTINGS_LIST,
	setIsRelationshipSettingsListLoadingAction,
	setPaginationAction,
	setRelationshipSettingsListAction,
} from './actions';
import { getRelationshipSettingsListRequest } from '../../api/requests';
import { DISMISS_TIME } from '../../api/constants';
import { notificationInit } from '../../modules/notifications/actions';
import { errorHandler } from '../../api/utils';
import { REQUEST_ERROR_MESSAGE } from '../relationship/constants';

export function* getRelationshipSettingsListSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsRelationshipSettingsListLoadingAction(true));
		}

		const { data, meta, message, toast } = yield call(getRelationshipSettingsListRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}
			yield put(
				setRelationshipSettingsListAction(
					data?.map(relationship => ({
						...relationship,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=relationship_settings&id=${
							relationship.id
						}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsRelationshipSettingsListLoadingAction(false));
	}
}

export default function* relationshipSettingsContainerSaga() {
	yield takeEvery(GET_RELATIONSHIP_SETTINGS_LIST, getRelationshipSettingsListSaga);
}
